export declare namespace InspectionStepBlockedViewTokenSections {
	interface Title {
		fontWeight: string;
		fontSize: string;
		color: string;
	}

	interface Message {
		color: string;
	}

	interface LoadingOverlay {
		background: string;
	}
}

export type InspectionStepBlockedViewTokens = {
	title: InspectionStepBlockedViewTokenSections.Title;
	message: InspectionStepBlockedViewTokenSections.Message;
	loadingOverlay: InspectionStepBlockedViewTokenSections.LoadingOverlay;
};

export const title: InspectionStepBlockedViewTokenSections.Title = {
	fontWeight: '600',
	fontSize: '1rem',
	color: '{text.color}',
};

export const message: InspectionStepBlockedViewTokenSections.Message = {
	color: '{text.muted.color}',
};

export const loadingOverlay: InspectionStepBlockedViewTokenSections.LoadingOverlay = {
	background: '{named.inspection.step.blocked.view.overlay.background}',
};

/**
 * Blocked view for inspection steps (geolocation permission, loading overlay).
 */
export default {
	title,
	message,
	loadingOverlay,
} satisfies InspectionStepBlockedViewTokens;
